import { ViewportScroller } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, OnInit ,Input} from '@angular/core';
import { Router } from '@angular/router';
import { loadURLSVGs, Masthead, Tooltip } from '@dds-uicore/all';
import { DataService } from '../data.service';
import { UserSessionInfo } from '../model/user-session-info';



@Component({
  selector: 'app-masthead-component',
  templateUrl: './masthead-component.component.html',
  styleUrls: ['./masthead-component.component.scss']
})
export class MastheadComponentComponent implements OnInit {

  @Input() userId:string;
  @Input() preferredFM:string;
  errorMsg: string = '';
  userName : string = 'User1';
  firstName : string = ''
  DFMLocation : string = 'Austin'
  posts = []
  isLoading : boolean
  userSessionInfo:UserSessionInfo;

  constructor(private router:Router, public viewportScroller : ViewportScroller, 
    private httpclient : HttpClient, private dataService : DataService
    ) { 
    // this.postDataService.getInfoFromServer()

  }
  ngOnInit(){
    this.isLoading = this.dataService.getIsLoading();
    // this.userName = this.postDataService.ssoNTID.split('_').join(' ')
    // this.postDataService.getInfoFromServer()

    loadURLSVGs([
      "https://uicore.dellcdn.com/1.3.3/svgs/dds__chevron-right.svg",
      "https://uicore.dellcdn.com/1.3.3/svgs/dds__search.svg",
      "https://uicore.dellcdn.com/1.3.2/svgs/dds__user.svg",
      "https://uicore.dellcdn.com/1.3.3/svgs/dds__cart.svg",
      "https://uicore.dellcdn.com/1.3.3/svgs/dds__menu-closed.svg",
      "https://uicore.dellcdn.com/1.3.3/svgs/dds__arrow-tri-solid-right.svg",
      "https://uicore.dellcdn.com/1.3.2/svgs/dds__brand-dell.svg",
      "https://uicore.dellcdn.com/1.3.2/svgs/dds__alert-info-cir.svg",
      "https://uicore.dellcdn.com/1.3.2/svgs/dds__globe-simple.svg"
      ], true); // boolean is for lazy loading
      
      // this.postDataService.getInfoFromServer()
      //   .then(data => {
      //     this.posts = data[0]
      //     console.log(this.posts)
      //     this.userName = this.posts['ntId']
      //     this.userName = this.userName.toLowerCase()
      //     this.postDataService.ssoNTID = this.posts['ntId']
      //   }).then(() => {
            // this.postData()
            // this.getRewardPoints()
        // })
        console.log('setting the user name to ',this.dataService.urlParams.userName);
      this.userName = this.dataService.urlParams.userName;
   
      const mastheadElement = document.querySelectorAll('[data-toggle=\"dds__msthd\"]');
      new Masthead(mastheadElement[0]);

      const tooltip = document.querySelectorAll('[data-toggle=\"dds__tooltip\"]');
      new Tooltip(tooltip[0])
     
      this.userName = this.dataService.urlParams.userName;
      this.userSessionInfo = this.dataService.getUserSessionInfo();
      console.log('User session info ',this.userSessionInfo)
      if(this.userSessionInfo != undefined){
        this.userName = this.userSessionInfo.userInfo.userName;
        this.DFMLocation = this.userSessionInfo.userInfo.userPreferredFM;
        
      }

      
  }

  public setUserName(userName:string)
  {
    this.userName = userName;
  }

  public setPreferredFM(preferredFM:string)
  {
    this.DFMLocation = preferredFM;
  }

    public routeToPath(path: string) {
      console.log('Routing to path ',path)
      // this.router.navigateByUrl(path, { skipLocationChange: false });
      this.router.navigate([path],{ skipLocationChange: true });
    }

    public routeToPathScroll(path: string, elementId: string) {
      this.router.navigateByUrl(path, { skipLocationChange: true });
      this.viewportScroller.scrollToAnchor(elementId);
    }

    public onClick(elementId: string): void { 
      this.viewportScroller.scrollToAnchor(elementId);
  }

  private getServerErrorMessage(error: HttpErrorResponse): string {
    switch (error.status) {
        case 404: {
            return `Not Found: ${error.message}`;
        }
        case 403: {
            return `Access Denied: ${error.message}`;
        }
        case 500: {
            return `Internal Server Error: ${error.message}`;
        }
        default: {
            return `Unknown Server Error: ${error.message}`;
        }

    }
}
postData(){
  this.httpclient.get('../getUserId').subscribe((data)=>
      {
        let dataTemp = data[0]
        this.userName = dataTemp['ntId']
      })
  
}


}
